module.exports = __webpack_public_path__ + "img/tab1.c058be51.png";